import * as React from 'react';
import { parseInt } from 'lodash';
import styled from 'styled-components';
import { colors } from '@/themes/jl-money/constants/colors';
import { DropdownFiltered, InputRange } from '@zopauk/react-components';
import { loanSettings } from '@/components/LoanForm/Calculator/constants';
import { DropdownItem } from '@zopauk/react-components/types/components/molecules/DropdownFiltered/DropdownFiltered';

type RepAprTermProps = {
  onChange: (value: number) => void;
  value: number;
};

export const MinusIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" width={14} height={2} {...props}>
    <path d="M14 1.75H0V.25h14v1.5Z" fillRule="evenodd" clipRule="evenodd" fill="#102B2B" />
  </svg>
);

export const PlusIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" height={14} fill="none" width={14} {...props}>
    <path
      d="M6.25 6.25V0h1.5v6.25H14v1.5H7.75V14h-1.5V7.75H0v-1.5h6.25Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#102B2B"
    />
  </svg>
);

const StyledDropdownField = styled(DropdownFiltered)`
  width: 100%;
  border-radius: 2px;
  box-shadow: none;
  
  &:hover {
        color: ${colors.jlMoneyGreyDark};
        background-color: ${colors.jlMoneyGreenLight};
        box-shadow: 0 0 0 1px ${colors.jlMoneyGrey};
      },
    },
`;

const StyledContainer = styled.div`
  margin-top: 16px;
`;

const StyledLabel = styled.label`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

const terms: number[] = [];
for (let i = loanSettings.min.term; i <= loanSettings.max.term; i++) {
  if (i % 12 === 0) {
    terms.push(i);
  }
}

const dropdownItems: DropdownItem[] = terms.map((term) => ({
  value: `${term.toString()} months (${Number(term.toString()) / 12} ${Number(term.toString()) === 12 ? 'year' : 'years'})`,
}));

export const RepAprTerm = ({ onChange, value }: RepAprTermProps) => (
  <>
    <StyledDropdownField
      value={`${value.toString()} months (${Number(value.toString()) / 12} ${Number(value.toString()) === 12 ? 'year' : 'years'})`}
      title={`Select a term between ${loanSettings.min.term} and ${loanSettings.max.term} months`}
      onChange={(e) => {
        if (e?.value) {
          onChange(parseInt(e.value, 10));
        }
      }}
      data-automation="ZA.loan-term-dropdowns"
      inputSize="fullLength"
      endIcon="chevron-down"
      items={dropdownItems}
      name="loan-term"
      label="Term"
    />
    <StyledLabel htmlFor="amount-range">Range of loan amounts in pounds</StyledLabel>
    <StyledContainer>
      <InputRange
        onChange={(e) => {
          if (e) {
            onChange(e);
          }
        }}
        data-automation="ZA.loan-amount-slider"
        customMinusIcon={<MinusIcon />}
        customPlusIcon={<PlusIcon />}
        min={loanSettings.min.term}
        max={loanSettings.max.term}
        id="amount-range"
        className="mx-3"
        value={value}
        step={12}
        controls
      />
    </StyledContainer>
  </>
);
